export enum AmplitudeCatalogStatus {
    Ended = 'Ended',
    Live = 'Live',
    None = 'none',
    Online = 'Online',
    Preview = 'Preview',
}

export enum AmplitudeLotStatus {
    BuyNow = 'Buy Now',
    Live = 'Live',
    None = 'none',
    Online = 'Online',
    Passed = 'Passed',
    Preview = 'Preview',
    Sold = 'Sold',
}
